module.exports = __webpack_public_path__ + "static/media/CS.e6c2cdb3.png";